import { timeZoneAbbrMap } from './timeZoneAbbrMap';

export function formatTimestampWithBrowserTimezone(utcString: string): string {
  const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const date = new Date(utcString);

  // Format: 21 July 2025 at 16:11
  const formattedDate = date.toLocaleString('en-GB', {
    timeZone,
    day: '2-digit',
    month: 'long',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  }).replace(',', ' at');

  const abbr = timeZoneAbbrMap[timeZone] || getFallbackAbbreviation(date, timeZone);

  return `${formattedDate} (${abbr})`;
}

function getFallbackAbbreviation(date: Date, timeZone: string): string {
  try {
    const parts = new Intl.DateTimeFormat('en-US', {
      timeZone,
      timeZoneName: 'short',
    }).formatToParts(date);
    const zoneName = parts.find(part => part.type === 'timeZoneName');
    // Remove GMT+5, GMT+3 etc.
    if (zoneName?.value?.startsWith("GMT")) {
      return ''; // or return 'UTC' if you prefer a default
    }
    return zoneName?.value || '';
  } catch {
    return '';
  }
}
